<div class="period">
    <span class="period__text" (click)="onClickHandler()">
        {{ periodText }}
    </span>
</div>
